import { quotationDateFilter } from "./quotationDateFilter.js";

export function documentDateFilterLabel(range, now = new Date()) {
  const format = (date) => date.toLocaleDateString("en-AU", {
    day: "numeric", month: "long", year: "numeric",
  });
  if (range === "Overdue") return `Before ${format(now)}`;
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const end = new Date(start);
  if (range === "Due this week") {
    start.setDate(start.getDate() - ((start.getDay() + 6) % 7));
    end.setTime(start.getTime());
    end.setDate(end.getDate() + 6);
  } else if (range === "Due this month") {
    start.setDate(1);
    end.setMonth(end.getMonth() + 1, 0);
  } else {
    const { fromDate, toDate } = quotationDateFilter(range === "This quarter" ? "Quarter" : range, now);
    if (!fromDate) return `As of ${format(now)}`;
    const parse = (value) => {
      const [year, month, day] = value.split("-").map(Number);
      return new Date(year, month - 1, day);
    };
    return `${format(parse(fromDate))} – ${format(parse(toDate))}`;
  }
  return `${format(start)} – ${format(end)}`;
}
